import WhiteConfirmationContainer from './WhiteConfirmationContainer';

export default WhiteConfirmationContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/WhiteConfirmation/index.js